import { updateKeyInStore } from 'App';
import { store } from 'app/redux/store';
import { countries } from 'countries';
import * as Yup from 'yup';
import { requiredFiles } from '../../../useValidateQuestionnaire';
import {
  FieldArrayKeysKeys,
  updateFieldArrayKey,
  updateKey,
  UsCorpOrPartnershipStateValues,
} from './slice';

// "predicate": "Displayed in case the user selects \"Yes\" to the \"I have a US Corporation or Partnership\" question in the general tab.",

export const fields: IBaseField<
  keyof UsCorpOrPartnershipStateValues | FieldArrayKeysKeys
>[] = [
  {
    name: 'usCorpList',
    label: 'What is the business structure?',
    type: 'select',
    options: [
      {
        label: 'C-Corp',
        value: 'C-Corp',
      },
      {
        label: 'S-Corp',
        value: 'S-Corp',
      },
      {
        label: 'Not for profit',
        value: 'Not for profit',
      },
      {
        label: 'SMLLC',
        value: 'SMLLC',
      },
      {
        label: 'LLC',
        value: 'LLC',
      },
    ],

    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
  },
  {
    name: 'wantUsToPrepareCorporateReturn',
    label: 'DO you want Us to prepare the corporate return?',
    type: 'radio',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependencies: [
      {
        dependenciesTitle: 'Corporation Info',
        name: 'nameOfCorporation',
        label: 'Name of corporation',
        type: 'text',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        placeholder: 'Enter...',
      },
      {
        name: 'whatDoesTheBusinessDo',
        label: 'What does the business do?',
        type: 'text',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        placeholder: 'Enter...',
      },
      {
        name: 'streetAddress',
        label: 'Street Address',
        type: 'text',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        placeholder: 'Enter...',
      },
      {
        name: 'city',
        label: 'City',
        type: 'text',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        placeholder: 'Enter...',
      },
      {
        name: 'stateOrProvince',
        label: 'State or Province',
        type: 'text',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        placeholder: 'Enter...',
      },
      {
        name: 'postCode',
        label: 'Post Code',
        type: 'text',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        placeholder: 'Enter...',
      },

      {
        name: 'country',
        label: 'Country',
        type: 'country',
        placeholder: 'Select Country',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
      },

      {
        name: 'corporateAccountingPeriod',
        label: 'Corporate Accounting Period',
        type: 'dateRange',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
      },
      {
        name: 'dateOfIncorporation',
        label: 'Date of Incorporation',
        type: 'date',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        placeholder: 'Select Date',
      },
      {
        name: 'endOfTaxYear',
        label: 'End of Tax Year',
        type: 'date',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        placeholder: 'Select Date',
      },

      {
        name: 'countryOfIncorporation',
        label: 'Country of Incorporation',
        type: 'country',
        placeholder: 'Select Country',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
      },
      {
        name: 'corporationForeignTaxIdNumberifAny',
        label: 'Corporation Foreign Tax ID Number (if any)',
        type: 'text',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        placeholder: 'Enter...',
      },
      {
        name: 'haveYouFiledForm8858Or8832InThePast',
        label:
          'Have you filed form 8858 Foreign Disregard entity or 8832 C corporation Election?',
        type: 'radio',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
      },
      {
        name: 'areYouPersonallyResponsideForTheCorporateFiling',
        label: 'Are you personally responside for the corporate filing?',
        type: 'radio',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),

        dependencies: [
          {
            name: 'foreginAgentOfCorporationNameAddressAndCountryOfLocation',
            label:
              'Foregin Agent of Corporation: Name, address and country of location',
            type: 'textarea',
            predicate: (value) => value === 'no',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
            placeholder: 'Enter...',
          },
          {
            name: 'custodianOfCorporateAccountingRecordsnameAddressAndCountry',
            label:
              'Custodian of corporate accounting records:Name, address, and country',
            type: 'text',
            predicate: (value) => value === 'no',
            tooltip: 'textarea',
            comment: true,
            effect: updateKeyInStore(updateKey),
            placeholder: 'Enter...',
          },
        ],
      },
      {
        dependenciesTitle: 'Ownership',
        name: 'dateYouAcquiredAtLeastA10OwnershipInTheCorporation',
        label: 'Date you acquired at least a 10% ownership in the Corporation',
        type: 'date',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        placeholder: 'Select Date',
      },
      {
        name: 'didYouAcquireOrDisposeOfSharesDuringYear',
        label: 'Did you acquire or dispose of shares during {year}',
        type: 'radio',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),

        dependencies: [
          {
            name: 'pleaseProvideDetails',
            label: 'Please provide details',
            type: 'text',
            predicate: (value) => value === 'yes',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
            placeholder: 'Enter...',
          },
        ],
      },
      {
        name: 'areYouADirectorOfTheCorporation',
        label: 'Are you a director of the Corporation?',
        type: 'radio',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
      },
      {
        name: 'areYouAnOfficerOfTheCorporation',
        label: 'Are you an officer of the Corporation?',
        type: 'radio',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
      },
      {
        name: 'doesYorSpouseOwnSharesInTheSameCorporation',
        label: 'Does yor spouse own shares in the same corporation?',
        subLabel: () => (
          <p>This is required even if your spouse is a non-US person</p>
        ),
        type: 'radio',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),

        dependencies: [
          {
            name: 'spouseName',
            label: 'Spouse Name',
            type: 'text',
            predicate: (value) => value === 'yes',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
            placeholder: 'Enter...',
          },
          {
            name: 'spouseTaxIdifAvailable',
            label: 'Spouse Tax ID (if Available)',
            type: 'text',
            predicate: (value) => value === 'yes',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
            placeholder: 'Enter...',
          },
          {
            name: 'numberOfSharesYourSpouseOwnsInCorporationifAny',
            label: 'Number of shares your spouse owns in corporation (if Any)',
            type: 'text',
            predicate: (value) => value === 'yes',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
            placeholder: 'Enter...',
          },
        ],
      },
      {
        name: 'totalNumberOfIssuedSharesInTheCorporation',
        label: 'Total number of issued shares in the Corporation',
        type: 'text',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        placeholder: 'Enter...',
      },

      {
        name: 'pleaseProvideDetailsAboutAllUsOwnersincludingYourselfOfTheCorporationInTheTableBelow',
        label:
          'Please provide details about All US owners (including yourself) of the corporation in the table below',
        type: 'fieldArray',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: (payload) => store.dispatch(updateFieldArrayKey(payload)),
        defaultDependency: {
          name: null,
          ssn: null,
          address: null,
          SharesOwnedAtBeginningOfAccountingPeriod: null,
          SharesOwnedAtEndOfAccountingPeriod: null,
          VotingPower: null,
        },
        dependencies: [
          {
            name: 'name',
            label: 'Name',
            type: 'text',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
            placeholder: 'Enter...',
          },
          {
            name: 'ssn',
            label: 'SSN',
            type: 'maskedInput',
            mask: '999-99-9999',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
          },
          {
            name: 'address',
            label: 'Address',
            type: 'text',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
            placeholder: 'Enter...',
          },
          {
            name: 'SharesOwnedAtBeginningOfAccountingPeriod',
            label: '# Shares owned at beginning of accounting period',
            type: 'text',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
            placeholder: 'Enter...',
          },
          {
            name: 'SharesOwnedAtEndOfAccountingPeriod',
            label: '# Shares owned at end of accounting period',
            type: 'text',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
            placeholder: 'Enter...',
          },
          {
            name: 'VotingPower',
            label: '% voting power',
            type: 'text',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
            placeholder: 'Enter...',
          },
        ],
      },
      {
        name: 'pleaseProvideDetailsAboutAllNonUsOwnersInTheTableBelow',
        label:
          'Please provide details about all Non-US owners in the table below',
        type: 'fieldArray',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: (payload) => store.dispatch(updateFieldArrayKey(payload)),
        defaultDependency: {
          name: null,
          address: null,
          SharesOwnedAtBeginningOfAccountingPeriod: null,
          SharesOwnedAtEndOfAccountingPeriod: null,
          ifEntitynotAPersonCountryOfIncorportion: null,
          relationToYouifAny: null,
        },
        dependencies: [
          {
            name: 'name',
            label: 'Name',
            type: 'text',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
            placeholder: 'Enter...',
          },
          {
            name: 'address',
            label: 'Address',
            type: 'text',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
            placeholder: 'Enter...',
          },
          {
            name: 'SharesOwnedAtBeginningOfAccountingPeriod',
            label: '# Shares owned at beginning of accounting period',
            type: 'text',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
            placeholder: 'Enter...',
          },
          {
            name: 'SharesOwnedAtEndOfAccountingPeriod',
            label: '# Shares owned at end of accounting period',
            type: 'text',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
            placeholder: 'Enter...',
          },
          {
            name: 'ifEntitynotAPersonCountryOfIncorportion',
            label: 'IF Entity (Not A Person), Country of Incorportion',
            type: 'text',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
            placeholder: 'Enter...',
          },
          {
            name: 'relationToYouifAny',
            label: 'Relation to you (if any)',
            type: 'text',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
            placeholder: 'Enter...',
          },
        ],
      },
      {
        name: 'doAllUsOwnersCollectivelyOwnMoreThan50',
        label: 'Do all US owners collectively own more than 50%?',
        subLabel: () => <p>Critical to determine your filing requirements</p>,
        type: 'radio',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),

        dependencies: [
          {
            name: 'doYouHaveKnowledgeOfWhetherTheNonUSOwnersOwnAUSPartnership',
            label:
              'Do you have knowledge of whether the non-US owners own a US partnership, US trust, are a beneficiary of a US trust, or own 50% or more of a US corporation?',
            type: 'radio',
            predicate: (value) => value === 'no',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),

            dependencies: [
              {
                name: 'pleaseProvideDetailsAboutAllNonUsOwnersOwnershipOfSeparateEntitiesInTheTableBelow',
                label:
                  'Please provide details about all non-US owners ownership of separate entities in the table below',
                type: 'fieldArray',
                predicate: (value) => value === 'yes',
                tooltip: '',
                comment: true,
                effect: (payload) =>
                  store.dispatch(updateFieldArrayKey(payload)),
                defaultDependency: {
                  nonUsOwnerName: null,
                  entityName: null,
                  ownershipOrInterestInTrust: null,
                },
                dependencies: [
                  {
                    name: 'nonUsOwnerName',
                    label: 'Non-US Owner name',
                    type: 'text',
                    tooltip: '',
                    comment: true,
                    effect: updateKeyInStore(updateKey),
                    placeholder: 'Enter...',
                  },
                  {
                    name: 'entityName',
                    label: 'Entity Name',
                    type: 'text',
                    tooltip: '',
                    comment: true,
                    effect: updateKeyInStore(updateKey),
                    placeholder: 'Enter...',
                  },
                  {
                    name: 'ownershipOrInterestInTrust',
                    label: 'Ownership % or Interest In trust as a beneficiary',
                    type: 'text',
                    tooltip: '',
                    comment: true,
                    effect: updateKeyInStore(updateKey),
                    placeholder: 'Enter...',
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        dependenciesTitle: 'Financials',
        name: 'didTheCorporationPayYouASalaryInYear',
        label: 'Did the Corporation pay you a Salary in {year}?',
        type: 'radio',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),

        dependencies: [
          {
            name: 'salaryPaidToYouByTheCorporationForYear',
            label: 'Salary paid to you by the corporation for year',
            type: 'currency',
            predicate: (value) => value === 'yes',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
          },
        ],
      },
      {
        name: 'didTheCorporationExtendYouAnyLoansInYear',
        label: 'Did the Corporation extend you any loans in {year}?',
        type: 'radio',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),

        dependencies: [
          {
            name: 'whatWasTheAmount',
            label: 'What was the amount?',
            type: 'currency',
            predicate: (value) => value === 'yes',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
          },
        ],
      },
      {
        name: 'didYouLoadAnyFundsToTheCorporationInYear',
        label: 'Did you load any funds to the corporation in {year}?',
        type: 'radio',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),

        dependencies: [
          {
            name: 'whatWasTheAmount',
            label: 'What was the amount?',
            type: 'currency',
            predicate: (value) => value === 'yes',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
          },
        ],
      },
      {
        name: 'didYouTransferPropertyOrCashToTheCorporationInYear',
        label:
          'Did you transfer property or cash to the corporation in {year}?',
        type: 'radio',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),

        dependencies: [
          {
            name: 'whichAssetDidYouTransfer',
            label: 'Which asset did you transfer?',
            subLabel: () => (
              <p>
                Property transfers may trigger additional filing requirements
                (Form 926)
              </p>
            ),
            type: 'select',
            options: [
              {
                label: 'None',
                value: 'None',
              },
              {
                label: 'Cash',
                value: 'Cash',
              },
              {
                label: 'Securities',
                value: 'Securities',
              },
              {
                label: 'Real Estate',
                value: 'Real Estate',
              },
            ],
            predicate: (value) => value === 'yes',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),

            dependencies: [
              {
                name: 'howMuchDidYouTransfer',
                label: 'How much did you transfer?',
                type: 'currency',
                predicate: (value) =>
                  value === 'Cash' ||
                  value === 'Securities' ||
                  value === 'Real Estate',
                tooltip: '',
                comment: true,
                effect: updateKeyInStore(updateKey),
              },
            ],
          },
        ],
      },
      {
        name: 'didYouReceiveDividendsOrOtherDistributionsFromTheCorporationDuringYear',
        label:
          'Did you receive dividends or other distributions from the Corporation during {year}?',
        type: 'radio',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),

        dependencies: [
          {
            name: 'pleaseDescribeDistributionAndAmount',
            label: 'Please describe distribution and amount',
            type: 'textarea',
            predicate: (value) => value === 'yes',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
            placeholder: 'Enter...',
          },
        ],
      },
      {
        name: 'doesTheCorporationHaveAnyInvestmentIncome',
        label: 'Does the corporation have any investment income?',
        subLabel: () => (
          <p>
            This includes all non-active income; ie rental, stocks, dividends,
            etc
          </p>
        ),
        type: 'radio',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
      },
      {
        name: 'areYouASignatryAuthorityOnTheCorporateBankAccountsOrOtherFinancialAccounts',
        label:
          'Are you a signatry authority on the corporate bank accounts or other financial accounts?',
        subLabel: () => (
          <p>
            If yes Please input these accounts into the Non-US Financial
            Accounts Tab
          </p>
        ),
        type: 'radio',
        predicate: (value) => value === 'yes',

        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
      },

      {
        name: 'pleaseUploadDocumentShowingCorporateDetailsDateOfIncorporationAndShareOwnershipForAllShareholders',
        label:
          'Please upload document showing corporate details, date of incorporation, and share ownership for all shareholders',
        type: 'upload',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
      },
      {
        name: 'pleaseUploadCorporationBalanceSheet',
        label: 'Please upload Corporation balance sheet',
        type: 'upload',
        predicate: (value) => value === 'yes',

        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
      },
      {
        name: 'pleaseUploadTheCorporationsIncomeStatement',
        label: "Please upload the corporation's Income Statement",
        type: 'upload',
        predicate: (value) => value === 'yes',

        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
      },
      {
        name: 'copyOfLastFiledFormCorporateTaxReturnifWasFilderBefore',
        label:
          'Copy of last filed form corporate tax return (if was filder before)',
        type: 'upload',
        predicate: (value) => value === 'yes',

        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
      },

      {
        name: 'haveYouFiledForm1120SBefore',
        label: 'Have you filed form 1120-S before?',
        type: 'radio',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),

        dependencies: [
          {
            name: 'haveYouFiledForm2553SBefore',
            label: 'Have you filed form 2553 before?',
            type: 'radio',
            predicate: (value) => value === 'no',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
          },
          {
            name: 'wouldYouLikeUsToPrepareThisFormForYouWithoutThisForm',
            label:
              'Would you like Us to prepare this form for you? Without this form, this corporation is not an S-Corp.',
            type: 'radio',
            predicate: (value) => value === 'no',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
          },
          {
            name: 'pleaseUploadCopyOfFiledForm2553',
            label: 'Please upload copy of filed Form 2553',
            type: 'upload',
            predicate: (value) => value === 'yes',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
          },
        ],
      },
    ],
  },
];

export const validationSchema = Yup.object().shape({});
